import { uploadWithProgress } from '@/api/transport';
import { type PortalDeposit, portalDepositSchema } from '@/schemas/cashierSession.schema';

export function postProof(
  token: string,
  utr: string,
  file: File,
  onProgress: (percent: number | null) => void,
  signal: AbortSignal,
): Promise<PortalDeposit> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('utr', utr);

  return uploadWithProgress(
    `/v1/cashier/${encodeURIComponent(token)}/proof`,
    formData,
    portalDepositSchema,
    onProgress,
    signal,
  );
}
